"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudLicenseJobTypes = void 0;
/**
 * CloudLicenseJobTypes are different types of jobs that are run on a cloud site
 */
var CloudLicenseJobTypes;
(function (CloudLicenseJobTypes) {
    CloudLicenseJobTypes["DEACTIVATE_CLOUD_SITE"] = "DEACTIVATE_CLOUD";
    CloudLicenseJobTypes["DELETE_CLOUD_SITE"] = "DELETE_CLOUD";
    CloudLicenseJobTypes["REACTIVATE_CLOUD_SITE"] = "REACTIVATE_CLOUD";
    CloudLicenseJobTypes["RENAME_CLOUD_SITE"] = "RENAME_CLOUD";
})(CloudLicenseJobTypes = exports.CloudLicenseJobTypes || (exports.CloudLicenseJobTypes = {}));
